import { Box, TextButton } from '@wix/design-system';
import { ChevronLeft } from '@wix/wix-ui-icons-common/lazy';
import React from 'react';
import s from './headerWrapper.scss';
import { DomainSearchGateModule } from '../../module/domainSearchGate.module';
import { useIsMobile } from '../../hooks/useIsMobile';
export const BackButton = _ref => {
  let onClick = _ref.onClick;
  const _DomainSearchGateModu = DomainSearchGateModule.internals.useTranslations(),
    t = _DomainSearchGateModu.t;
  return /*#__PURE__*/React.createElement(TextButton, {
    className: s.backButton,
    onClick: onClick,
    prefixIcon: /*#__PURE__*/React.createElement(ChevronLeft, null),
    size: "medium",
    weight: "thin",
    skin: "dark"
  }, t('domain_search_gate.domain_gate.back'));
};
export const HeaderWrapper = _ref2 => {
  let onBackClick = _ref2.onBackClick,
    _ref2$verticalAlign = _ref2.verticalAlign,
    verticalAlign = _ref2$verticalAlign === void 0 ? 'middle' : _ref2$verticalAlign,
    children = _ref2.children;
  const isMobile = useIsMobile();
  return /*#__PURE__*/React.createElement(Box, {
    gap: isMobile ? 'SP2' : onBackClick ? 'SP4' : undefined,
    direction: isMobile ? 'vertical' : 'horizontal',
    verticalAlign: verticalAlign,
    width: "100%"
  }, /*#__PURE__*/React.createElement(Box, {
    flex: 1
  }, onBackClick && /*#__PURE__*/React.createElement(BackButton, {
    onClick: onBackClick
  })), /*#__PURE__*/React.createElement(Box, {
    align: "center",
    textAlign: "center"
  }, children), !isMobile && /*#__PURE__*/React.createElement(Box, {
    flex: 1
  }));
};
//# sourceMappingURL=HeaderWrapper.js.map